import React from "react";
import { FOOTER } from "../../../layout/eng/footer";
import { SUBHEADER } from "../../../layout/eng/subheader";
import { EN_Comm } from "../../../parts/eng/intro/comment";
import { Helmet } from "react-helmet";
class EN_COMMENT extends React.Component {
  render() {
    return (
      <main id="content">
        <SUBHEADER />
        <div id="intro">
          <EN_Comm />
        </div>
        <FOOTER />
      </main>
    );
  }
}
export default EN_COMMENT;
